import axios from 'axios';
import querystring from 'qs';
import summarybar from './summarybar.vue';
import moment from 'moment';
import addqualification from './addqualification.vue';
export default {
    name: 'SideBar',
    props: {
        date: {
            type: Date,
        },
    },
    components: {
        summarybar
    },
    computed: {
        contractuser() {
            return this.result.filter(x => x.contractType == 1);
        },
        nocontractuser() {
            return this.result.filter(x => x.contractType == 0);
        },
      
    },
    data() {
        return {
            initialized: false,
            result: null,
            list: [],
            ctype: 1,
            search: ''
        };
    },
    watch: {
        search() {
            this.filterList();
        },
        date() {
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //console.log(this.date)
            this.initialized = false;
            const params = {
                date: this.date,
            };
            let url = APIURL + '/activity/allattendants?' + querystring.stringify(params);
            let response = axios.get(url, params)
                .then(resp => {
                    this.result = resp.data;
                    this.setList();
                });
            Promise.all([response])
                .then(() => {
                    this.initialized = true;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        getDate(newdate) {
            return moment.utc(newdate).format('ddd HH:mm');
        },
        showAttendant(val) {
            this.ctype = val;
            this.filterList();
        },
        filterList() {
            this.setList();
            this.list = this.list.filter(x => x.name.toLowerCase().includes(this.search.toLowerCase()));
        },
        setList() {
            if (this.ctype == -1) {
                this.list = [...this.result];
            }
            else
                this.list = this.result.filter(x => x.contractType == this.ctype);
        },
        setQualification() {
            let self = this;
            console.log(this.$t('title.educationqualification'))
            this.$vuedals.open({
                title: this.$t('title.educationqualification'),               
                component: addqualification,
                size: 'lg',
                escapable: true,
                onClose() {
                    self.fetch();
                }
            });
        }

    }
};